import { DashboardFigure } from "@components/Dashboards/shell";

type Props = {
  lastSessionTime?: string | null;
  prominent?: boolean;
};

export const ResourceGroupUsageTimeStat = ({
  lastSessionTime,
  prominent,
}: Props) => {
  const lastUsedTime = lastSessionTime ? new Date(lastSessionTime) : null;

  const formatTimeAgo = (date: Date | null): string => {
    if (!date) return "Never";
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();

    if (diffMs < 0) return "In the future";

    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDays > 0) {
      return `${diffDays} day${diffDays !== 1 ? "s" : ""} ago`;
    }
    return "Today";
  };

  return (
    <DashboardFigure
      prominent={prominent}
      stacked
      label="Last session"
      value={formatTimeAgo(lastUsedTime)}
    />
  );
};
